export const ApprovalOperation = {
  REQUEST: 'REQUEST',
  APPROVE: 'APPROVE',
  CANCEL: 'CANCEL',
  /**
   * @deprecated use CANCEL instead
   */
  RECALL: 'RECALL',
  REJECT: 'REJECT'
};